const plainAdminTemplate = Object.freeze({
  id: "plain-admin",
  name: "Plain Admin",
  description: "Neutral sidebar administration template based on the approved plainUI reference.",
  defaultTheme: "light",
  supportedThemes: Object.freeze(["light", "dark", "system"]),
});

export default plainAdminTemplate;
